// extracted by mini-css-extract-plugin
module.exports = {"form":"styles_form__RJA3-","row":"styles_row__1W6Uc"};